<template>
  <div>
    <div class="title">
      {{ $t("referring_domains") }}
    </div>
    <div>
      <highcharts
        ref="highchart"
        :options="chartOptions"
      ></highcharts>
    </div>
  </div>
</template>

<script>
import Highcharts from "highcharts";
import { Chart } from "highcharts-vue";
import { epochDayToDateTime } from "@/javascripts/dateHelpers";

export default {
  props: {
    data: Object,
  },
  components: {
    highcharts: Chart,
  },
  data() {
    return {
      chartOptions: {
        chart: {
          height: 300,
          zoomType: "x",
        },
        title: {
          text: "",
          useHTML: true,
        },
        xAxis: {
          type: "datetime",
        },
        yAxis: {
          title: {
            text: this.$i18n.t("referring_domains"),
          },
        },
        tooltip: {
          pointFormatter: function () {
            return "<b>" + this.y + "</b>";
          },
        },
        series: [],
        credits: {
          enabled: false,
        },
      },
    };
  },
  methods: {
    updateSeries() {
      if (this.data && Object.keys(this.data.history).length > 0) {
        this.chartOptions.series = [];
        const referringDomainsData = [];
        for (const [key, value] of Object.entries(this.data.history)) {
          if (value.referringDomainsWithEquity) {
            referringDomainsData.push({
              x: new Date(key).getTime(),
              y: value.referringDomainsWithEquity,
            });
          }
        }

        this.chartOptions.series.push({
          name: this.$i18n.t("referring_domains"),
          data: referringDomainsData,
        });
      } else {
        this.chartOptions.series = [];
      }
    },
  },
  mounted() {
    this.updateSeries();
  },
  watch: {
    data() {
      this.updateSeries();
    },
  },
};
</script>

<style lang="scss" scoped>
@use "styles/variables" as *;

.title {
  margin-bottom: 1rem;
  text-align: center;
  font-size: 1.5rem;
}
</style>

<i18n>
{
  "en": {
    "referring_domains": "Referring Domains"
  },
  "fr": {
    "referring_domains": "Domaines référents"
  },
  "de": {
    "referring_domains": "Verweisende Domains"
  }
}
</i18n>
